import React, {useState, useEffect} from 'react';

import logo from './logo.svg';
import './App.css';

function App() {
  const [serverText, setText] = useState(0);
  
  useEffect(() => {
    fetch('/api/helloworld').then(response => {
      if (response.ok) {
		return response.json();
	  } else {
	    return {'text': 'Server error!'}
	  }
    }).then(data => {
      setText(data.text);
    });
  }, []);
    
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          {serverText}
        </a>
      </header>
    </div>
  );
}

export default App;
